module.exports = __webpack_public_path__ + "img/p3-title-icon.55713300.png";